import { Colors } from '@kvika/audur-theme'

import AudurTooltip from '../audurTooltip/AudurTooltip'

import styles from './audurRadioButton.module.scss'

type IAudurRadioButtonProps = {
	label: string
	name: string
	value: string | number
	checked: boolean
	onChange: () => void
	tooltip?: string
}

const AudurRadioButton = (props: IAudurRadioButtonProps) => {
	const { label, name, value, checked, onChange, tooltip } = props

	const onChangeHandler = () => {
		onChange()
	}

	return (
		<div className={styles.audurRadio}>
			<input
				type='radio'
				name={name}
				value={value}
				className={styles.audurRadioInput}
				checked={checked}
				onChange={onChangeHandler}
			/>
			{}
			<span className={styles.audurRadioButton} onClick={onChangeHandler} />
			<span>{label}</span>
			{tooltip && (
				<span className={styles.tooltip}>
					<AudurTooltip
						text={tooltip}
						id={`${name}-tooltip`}
						infoOutlinedColor={Colors.LightGray}
						activeInfoOutlinedColor={Colors.Silver}
						backgroundColor={Colors.Silver}
						hideCloseIcon
						hideTitleRow
					/>
				</span>
			)}
		</div>
	)
}

export default AudurRadioButton
